import { UNLOCK_FEATURE_DIALOG_OPEN, UNLOCK_FEATURE_DIALOG_CLOSE } from './actions'

const initialState = false

export default (state = initialState, action) => {
  switch (action.type) {
    case UNLOCK_FEATURE_DIALOG_OPEN:
      return true

    case UNLOCK_FEATURE_DIALOG_CLOSE:
      return false

    default:
      return state
  }
}
